import { RoleOptions, RoleSearchOptions } from 'components/Dashboard/Filters/FiltersData/StakeholdersFilters';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const staffersFilters = [...RoleOptions, ...RoleSearchOptions]?.filter((item) =>
  item?.name?.toLowerCase()?.includes('staff')
);

// Single source of truth for the URL param - was being re-read with two different
// helpers (getUrlParam vs URLSearchParams.get) across the table, export and send-email call sites.
export const getIncludeStaff = () => getUrlParam('includeStaff') === 'true';

// The directory hides staffers by default; any query built from the directory's filters
// (table, export, send-email) must exclude them the same way or it'll return more contacts
// than the directory shows.
const getContactFiltersExcludingStaff = ({ filters, includeStaff }) => {
  const filtersValues = staffersFilters?.map((item) => item?.filterValue ?? item?.name);
  const includeStaffers = includeStaff || filters?.some((item) => filtersValues?.includes(item?.value));

  if (includeStaffers) return filters;

  const noStaffFilter = staffersFilters?.map((item) => ({
    field: 'categories',
    value: item?.filterValue ?? item?.name,
    operator: 'str_not_eq',
  }));

  return [...noStaffFilter, ...filters];
};

export default getContactFiltersExcludingStaff;
